const BASEURL = process.env.REACT_APP_BACKEND_URL;
const FINANCE_URL = process.env.REACT_APP_PERMISSION_APIS;
// Lease Finance backend (Agent Master's api/general/agentmaster/* lives here).
const LEASE_FINANCE_BASEURL = (process.env.REACT_APP_BACKEND_URL_LeaseFinance || '').replace(/\/+$/, '');
const LEASE_FINANCE_Localhost_BASEURL = (process.env.REACT_APP_BACKEND_URL_LeaseFinance_Localhost || '').replace(/\/+$/, '');

export const endPoint = {
  GET_UNITNO_DATA: `${BASEURL}/api/LeaseCommon/GetCommonData`,
  GET_CUSTOMER_LAZY_NAME: `${BASEURL}/api/LeaseCommon/GetCustomersByName`,
  GET_CURRENCY_PER: `${FINANCE_URL}/api/finance/currencies/listing`,

  // Lease Agreement / Lease Renewal (ported from Qfinity-POS-Frontend-LeaseAggrement_k)
  CREATE_LEASE_AGRE: `${BASEURL}/api/LeaseAgreement/CreateLease`,
  UPDATE_LEASE_AGRE: `${BASEURL}/api/SaleOrder/Update`,
  GET_LEASE_AGRE: `${BASEURL}/api/LeaseAgreement/Get`,
  DELETE_LEASE_AGRE: `${BASEURL}/api/LeaseAgreement/DeleteLease`,
  EDIT_LEASE_AGRE: `${BASEURL}/api/LeaseAgreement/EditLease`,
  RENEW_LEASE_AGRE: `${BASEURL}/api/LeaseAgreement/RenewLease`,
  CREATE_LEASE_ADDITION_AMOUNT_RENEW: `${BASEURL}/api/LeaseAgreement/CreateLeaseAdditionAmountRenew`,
  SAVE_ADDITION_AMOUNT_RENEW_LINES: `${BASEURL}/api/LeaseAgreement/SaveAdditionAmountRenewLines`,
  RENEW_LEASE_BULK: `${BASEURL}/api/LeaseAgreement/RenewLeaseBulk`,
  GET_UNITNO_DROP: `${BASEURL}/api/LeaseAgreement/GetDropDown`,
  GET_PROPERT_DROP: `${BASEURL}/api/LeaseAgreement/GetLeaseCreateDdls`,
  GET_COMMON_PROP: `${BASEURL}/api/LeaseProposal/GetCommonData`,
  GET_PAYMENT_PLAN: `${BASEURL}/api/LeaseCommon/LeasePaymentPlan`,

  // Dashboard
  GET_DASHBOARD_LIST: `${BASEURL}/api/LeaseDashboard/GetDashboardUnits`,
  GET_DASHBOARD_DROP: `${BASEURL}/api/LeaseDashboard/GetMultipleDropdown`,
  GET_DASHBOARD_CASCAD: `${BASEURL}/api/LeaseDashboard/GetCascadDropdown`,
  GET_DASHBOARD_STATS: `${BASEURL}/api/LeaseDashboard/GetDashboardStats`,
  // "Ask Pro360 AI" panel on the Property Dashboard - backend contract:
  // POST { question: string, context: string } -> { statusCode: 200, result: { answer: string } }
  // Lives on the Lease Finance backend, not the main lease API host.
  AI_ASK_DASHBOARD: `${LEASE_FINANCE_BASEURL}/api/leasedashboard/askai`,

  // Customer Master
  GET_CUSTOMER: `${BASEURL}/api/Customer/Get`,
  POST_CUSTOMER: `${BASEURL}/api/Customer/CreateCustomer`,
  DELETE_CUSTOMER: `${BASEURL}/api/Customer/GetCommonData`,
  EDIT_CUSTOMER: `${BASEURL}/api/Customer/EditCustomer`,
  CUSTOMER_CASCAD: `${BASEURL}/api/Customer/GetCascadDropdown`,
  CUSTOMER_COMMON: `${BASEURL}/api/Customer/GetCommonData`,
  CUSTOMER_MULTI: `${BASEURL}/api/Customer/GetMultipleDropdown`,

  // Community Master
  GET_COMMUNITY_LIST: `${BASEURL}/api/Community/GetAllCommunities`,
  GET_COMMUNITY_BY_ID: `${BASEURL}/api/Community/GetCommunityById`,
  POST_COMMUNITY: `${BASEURL}/api/Community/CreateCommunity`,
  UPDATE_COMMUNITY: `${BASEURL}/api/Community/UpdateCommunity`,
  DELETE_COMMUNITY: `${BASEURL}/api/Community/DeleteCommunity`,
  COMMUNITY_COMMON: `${BASEURL}/api/Community/GetCommonData`,
  COMMUNITY_MULTIDROP: `${BASEURL}/api/Community/GetMultipleDropdown`,
  COMMUNITY_CASCAD: `${BASEURL}/api/Community/GetCascadDropdown`,

  // Unit Master
  GET_UNIT_LIST: `${BASEURL}/api/UnitManagement/GetAll`,
  GET_UNIT_ID: `${BASEURL}/api/UnitManagement/GetById/`,
  GET_UNIT_MULTIDROP: `${BASEURL}/api/UnitManagement/GetMultipleDropdown`,
  GET_UNIT_CASCAD: `${BASEURL}/api/UnitManagement/GetCascadDropdown`,
  CREATE_UNIT: `${BASEURL}/api/UnitManagement/Create`,
  UPDATE_UNIT: `${BASEURL}/api/UnitManagement/Update`,
  DELETE_UNIT: `${BASEURL}/api/UnitManagement/Delete/`,
  GET_UNIT_COMMON: `${BASEURL}/api/UnitManagement/GetCommonData`,
  POST_UNIT_ADDITIONAL: `${BASEURL}/api/UnitManagement/InsertAllAdditionalDetails`,

  // Property Master
  GET_PROPERTY_LIST: `${BASEURL}/api/Property/GetAll`,
  POST_PROPERTY: `${BASEURL}/api/Property/CreateProperty`,
  UPDATE_PROPERTY: `${BASEURL}/api/Property/EditProperty`,
  PROPERTY_MULTIDROP: `${BASEURL}/api/Property/GetMultipleDropdown`,
  PROPERTY_CASCAD: `${BASEURL}/api/Property/GetCascadDropdown`,
  PROPERTY_COMMON_DATA: `${BASEURL}/api/Property/GetCommonData`,
  DELETE_PROPERTY: `${BASEURL}/api/Property/DeleteProperty`,
  GET_PROPERTY_BY_ID: `${BASEURL}/api/Property/GetPropertyById`,
  UPLOAD_PROPERTY_IMAGE: `${BASEURL}/api/Property/AddPropertyImage`,
  DELETE_PROPERTY_IMAGE: `${BASEURL}/api/Property/DeletePropertyImage`,
  GET_PROPERTY_IMAGE: `${BASEURL}/api/Property/GetPropertyImages`,

  // File Upload
  UNIT_FILE: `${BASEURL}/api/FileUpload/files`,
  GET_FILE: `${BASEURL}/api/FileUpload/list`,
  DELETE_FILE: `${BASEURL}/api/FileUpload/delete`,

  // Installment Invoice Email
  LEASE_RECEIPT_MULTIDROP: `${BASEURL}/api/LeaseReceipt/GetMultipleDropdown`,
  LEASE_RECEIPT_CASCAD: `${BASEURL}/api/LeaseReceipt/GetCascadDropdown`,
  LEASE_RECEIPT_COMMON: `${BASEURL}/api/LeaseReceipt/GetCommonData`,
  GET_INSTALLMENT_INVOICE: `${BASEURL}/api/InstallmentInvoice/Get`,

  // Unit Blocking (confirmed from Swagger)
  UNITBLOCKING_MULTIDROP: `${BASEURL}/api/UnitBlocking/GetMultipleDropdown`,
  UNITBLOCKING_CASCAD: `${BASEURL}/api/UnitBlocking/GetCascadDropdown`,
  UNITBLOCKING_COMMON: `${BASEURL}/api/UnitBlocking/GetCommonData`,
  CREATE_UNIT_BLOCKING: `${BASEURL}/api/UnitBlocking/CreateUnitBlocking`,
  BULK_UNIT_BLOCKING: `${BASEURL}/api/UnitBlocking/BulkUnitBlocking`,
  RELEASE_UNIT_BLOCKING: `${BASEURL}/api/UnitBlocking/ReleaseUnitBlocking`,
  BULK_RELEASE_UNIT_BLOCKING: `${BASEURL}/api/UnitBlocking/BulkReleaseUnitBlocking`,
  DELETE_UNIT_BLOCKING: `${BASEURL}/api/UnitBlocking/DeleteUnitBlocking/`,
  GET_ALL_UNIT_BLOCKINGS: `${BASEURL}/api/UnitBlocking/GetAllUnitBlockings`,
  GET_ALL_UNIT_BLOCKINGS_RELEASE: `${BASEURL}/api/UnitBlocking/GetAllUnitBlockingsRelease`,
  GET_UNIT_BLOCKING_BY_ID: `${BASEURL}/api/UnitBlocking/GetUnitBlockingById/`,

  // Lease Reports (LeaseReports controller - confirmed from Swagger)
  LEASE_REPORTS_MULTIDROP: `${BASEURL}/api/LeaseReports/GetMultipleDropdown`,
  LEASE_REPORTS_CASCAD: `${BASEURL}/api/LeaseReports/GetCascadDropdown`,
  LEASE_VACANT_UNITS_LIST: `${BASEURL}/api/LeaseReports/GetLeaseVacantUnits`,
  LEASE_CUSTOMER_CURRENT_BALANCE: `${BASEURL}/api/LeaseReports/GetCustomerCurrentBalance`,

  // Lease Proposal (ported from Qfinity-POS-Frontend-LeaseAggrement_k)
  GET_LEASE_PROP: `${BASEURL}/api/LeaseProposal/Get`,
  GET_DDLS_PROP: `${BASEURL}/api/LeaseProposal/GetProposalCreateDdls`,
  CREATE_LEASE_PROP: `${BASEURL}/api/LeaseProposal/CreateProposal`,
  EDIT_LEASE_PROP: `${BASEURL}/api/LeaseProposal/EditProposal`,

  // Approvals: Proposal Approval ("Lease Approval"), Agreement Approval, Invoice Approval
  GET_PROPOSAL_APPROVAL: `${BASEURL}/api/LeaseApproval/GetProposalApprovalList`,
  POST_PROPOSAL_APPROVAL: `${BASEURL}/api/LeaseApproval/SaveProposalApprovalList`,
  GET_LEASE_APPROVAL: `${BASEURL}/api/LeaseApproval/GetApprovalList`,
  POST_LEASE_APPROVAL: `${BASEURL}/api/LeaseApproval/SaveApprovalList`,
  GET_INVOICE_APPROVAL: `${BASEURL}/api/LeaseApproval/GetInvoiceApprovalList`,
  POST_INVOICE_APPROVAL: `${BASEURL}/api/LeaseApproval/SaveInvoiceApprovalList`,

  // Lease Termination
  GET_LEASE_TERMINATION: `${BASEURL}/api/LeaseTermination/Get`,
  POST_LEASE_TERMINATION: `${BASEURL}/api/LeaseTermination/CreateLeaseTermination`,
  TERMINATION_COMMON: `${BASEURL}/api/LeaseTermination/GetCommonData`,
  TERMINATION_MULTI: `${BASEURL}/api/LeaseTermination/GetMultipleDropdown`,
  TERMINATION_CASCAD: `${BASEURL}/api/LeaseTermination/GetCascadDropdown`,

  // Single Invoice / Installment Invoice
  GET_SINGLE_INVOICE: `${BASEURL}/api/SingleInvoice/Get`,
  GET_INVOICE_DROP: `${BASEURL}/api/SingleInvoice/GetLeaseSingleInvoiceDdls`,
  GET_INVOICE_CASCAD: `${BASEURL}/api/SingleInvoice/GetSingleInvoiceCascadDdls`,
  GET_INVOICE_COMMON: `${BASEURL}/api/SingleInvoice/GetSingleInvoiceCommonData`,
  POST_SINGLE_INVOICE: `${BASEURL}/api/SingleInvoice/Create`,
  POST_CREDIT_NOTE: `${BASEURL}/api/SingleInvoice/IssueCreditNote`,
  CASCAD_DROP: `${BASEURL}/api/LeaseReceipt/GetCascadDropdown`,
  RECEIPT_DROPDOWN: `${BASEURL}/api/LeaseReceipt/GetMultipleDropdown`,
  GET_INSTALL_INVOICE_LIST: `${BASEURL}/api/InstallmentInvoice/Get`,
  GET_INSTALL_INVOICE_DROP: `${BASEURL}/api/InstallmentInvoice/GetLeaseInstallmentInvoiceDdls`,
  GET_INSTALL_INVOICE_COMMON: `${BASEURL}/api/InstallmentInvoice/GetInstallmentInvoiceCommonData`,
  GET_INSTALL_INVOICE_CASCAD: `${BASEURL}/api/InstallmentInvoice/GetInstallmentInvoiceCascadDdls`,
  POST_INSTALL_INVOICE: `${BASEURL}/api/InstallmentInvoice/Create`,

  // Lease General Invoice
  GET_GENERAL_LIST: `${BASEURL}/api/GeneralInvoice/Get`,
  GET_GENERAL_MULTI: `${BASEURL}/api/GeneralInvoice/GetLeaseGeneralInvoiceDdls`,
  GET_GENERAL_CASCAD: `${BASEURL}/api/GeneralInvoice/GetGeneralInvoiceCascadDdls`,
  GET_GENERAL_COMMON: `${BASEURL}/api/GeneralInvoice/GetGeneralInvoiceCommonData`,
  POST_GENERAL: `${BASEURL}/api/GeneralInvoice/Create`,

  // Lease Receipt
  GET_RECEIPT: `${BASEURL}/api/LeaseReceipt/Get`,
  LEASE_NO_DATA: `${BASEURL}/api/LeaseReceipt/GetCommonData`,
  CREATE_LEASE_RECEIPT: `${BASEURL}/api/LeaseReceipt/CreateReceipt`,

  // Lease Bulk Receipt
  GET_BULK_RECEIPT: `${BASEURL}/api/LeaseBulkReceipt/Get`,
  CREATE_BULK_RECEIPT: `${BASEURL}/api/LeaseBulkReceipt/CreateReceipt`,
  MULTIDROP_BULK_RECEIPT: `${BASEURL}/api/LeaseBulkReceipt/GetMultipleDropdown`,
  CASCAD_BULK_RECEIPT: `${BASEURL}/api/LeaseBulkReceipt/GetCascadDropdown`,
  COMMON_BULK_RECEIPT: `${BASEURL}/api/LeaseBulkReceipt/GetCommonData`,
  // GET_DOC_STATUS_EDIT: intentionally left undefined - bulkReceiptListing.js
  // (ported as-is) calls this key but it was never defined in the source
  // project's own endPoint.js either. Confirm the real action with backend
  // before adding a URL here.

  // Lease Reverse Receipt
  REVERSE_CASCAD: `${BASEURL}/api/LeaseReverseReceipt/GetCascadDropdown`,
  REVERSE_COMMON: `${BASEURL}/api/LeaseReverseReceipt/GetCommonData`,
  REVERSE_MULTI: `${BASEURL}/api/LeaseReverseReceipt/GetMultipleDropdown`,
  POST_LEASE_REVERSE: `${BASEURL}/api/LeaseReverseReceipt/CreateReverseReceipt`,
  GET_LEASE_REVERSE: `${BASEURL}/api/LeaseReverseReceipt/Get`,

  // Lease Revenue Posting
  GET_REVENUE_LIST: `${BASEURL}/api/LeaseRevenue/Get`,
  GET_REVENUE_MULTI: `${BASEURL}/api/LeaseRevenue/GetMultipleDropdown`,
  GET_REVENUE_CASCAD: `${BASEURL}/api/LeaseRevenue/GetCascadDropdown`,
  GET_REVENUE_COMMON: `${BASEURL}/api/LeaseRevenue/GetCommonData`,
  POST_REVENUE: `${BASEURL}/api/LeaseRevenue/PostLeaseRevenue`,

  // Inventory Update (reuses GET_LEASE_AGRE, GET_UNITNO_DATA, TERMINATION_CASCAD/MULTI above)
  POST_INVENTORY: `${BASEURL}/api/LeaseAgreement/InventoryUpdate`,

  // Lease Reports (LeaseReports controller - additional actions beyond the
  // Unit Vacant Report / Customer Current Balance Report ones above; exact
  // literal keys the ported report pages call via getApiParamater('KEY', ...))
  REPORT_MULTI_DROP: `${BASEURL}/api/LeaseReports/GetMultipleDropdown`,
  REPORT_CASCAD: `${BASEURL}/api/LeaseReports/GetCascadDropdown`,
  REPORT_LEASE_UNIT: `${BASEURL}/api/LeaseReports/GetLeaseUnitsAvailability`,
  REPORT_LEASE_STATEMENT: `${BASEURL}/api/LeaseReports/GetLeaseStatement`,
  REPORT_TAX_STATEMENT: `${BASEURL}/api/LeaseReports/GetTaxStmtDetail`,
  REPORT_TENANT_INVOICE: `${BASEURL}/api/LeaseReports/GetTenantInvoiceReport`,
  REPORT_TENANT_OCCUPANCY: `${BASEURL}/api/LeaseReports/GetOccupancyReport`,
  REPORT_LEASE_OUTSTANDING: `${BASEURL}/api/LeaseReports/GetLeaseOutstanding`,
  REPORT_MONTH_WISE_REVENUE: `${BASEURL}/api/LeaseReports/GetMonthWiseRevenueReport`,
  REPORT_UNIT_MASTER_LIST: `${BASEURL}/api/LeaseReports/GetUnitMasterListReport`,
  REPORT_REVENUE_AGAINST_INVOICES: `${BASEURL}/api/LeaseReports/GetRevenueReportAgainstInvoices`,
  REPORT_AGING_ANALYSIS: `${BASEURL}/api/LeaseReports/AgingAnalysisLease`,
  REPORT_MOVE_IN_OUT: `${BASEURL}/api/LeaseReports/GetLeaseMoveInOut`,
  REPORT_LEASE_RECEIPTS: `${BASEURL}/api/LeaseReports/GetLeaseReceipts`,
  REPORT_PDC_LIST: `${BASEURL}/api/LeaseReports/GetPDCList`,
  REPORT_ACCRUED_RENT: `${BASEURL}/api/LeaseReports/GetAccruedRentReport`,
  // Overstay Days Report - confirmed via Swagger (query params: PropertyNo,
  // UnitNo, CustomerNo, PageNo, PageSize; response items: lease_No,
  // property_Name, unit_No, customerId, customerName, contractStart,
  // contractEnd, vacatedDate, vacantDays).
  REPORT_OVERSTAY_DAYS: `${BASEURL}/api/LeaseReports/GetLeaseVacantDaysReport`,

  // Bonus fix: these pre-existing report pages (built earlier, never wired to
  // the sidebar) call these exact keys too, which were missing entirely -
  // adding them here fixes those pages as a side effect of this same batch.
  REPORT_UNIT_LOSS: `${BASEURL}/api/LeaseReports/AvailableUnitRevenueLoss`,
  REPORT_LEASE_EXPIRY: `${BASEURL}/api/LeaseReports/GetLeaseExpiry`,
  REPORT_LEASE_RECEIPT_NO: `${BASEURL}/api/LeaseReports/GetLeaseReceiptLogReceiptNo`,
  REPORT_LEASE_RECEIPT_NARRATION: `${BASEURL}/api/LeaseReports/GetLeaseReceiptLogNarration`,
  REPORT_REFUND_ANALYSIS: `${BASEURL}/api/LeaseReports/GetRefundAnalysis`,
  REPORT_LEASE_REVENUE: `${BASEURL}/api/LeaseReports/GetLeaseRevenueRental`,
  LEASE_INVOICE_PRINT: `${BASEURL}/api/LeaseReports/LeaseInvoicePrint`,
  // balancePayment.js also calls COMMON_BLNC_REF and POST_BLNC_REF - no
  // matching action was found on the LeaseReports controller (or anywhere
  // else) via Swagger, so those two are left undefined rather than guessed.
  MULTI_BLNC_REF: `${BASEURL}/api/LeaseReports/GetMultipleDropdown`,
  CASCAD_BLNC_REF: `${BASEURL}/api/LeaseReports/GetCascadDropdown`,

  // Finance Posting: JV Import, Lease Invoice Import, Lease Receipt Import.
  // Source hardcodes these against http://leasefinanceapi.pro360erp.com with
  // no env var; this project already has that exact host available as
  // LEASE_FINANCE_BASEURL, so we use that instead of hardcoding it again.
  JV_IMPORT_SAVE: `${LEASE_FINANCE_BASEURL}/api/general/jvimport/save`,
  JV_IMPORT_SEARCH: `${LEASE_FINANCE_BASEURL}/api/general/jvimport/search`,
  JV_IMPORT_GROUPS: `${LEASE_FINANCE_BASEURL}/api/general/jvimport/getimportgroups`,
  JV_IMPORT_DELETE: `${LEASE_FINANCE_BASEURL}/api/general/jvimport/delete/`,
  LEASE_INVOICE_IMPORT_SAVE: `${LEASE_FINANCE_BASEURL}/api/general/leaseinvoiceimport/save`,
  LEASE_INVOICE_IMPORT_SEARCH: `${LEASE_FINANCE_BASEURL}/api/general/leaseinvoiceimport/search`,
  LEASE_INVOICE_IMPORT_GROUPS: `${LEASE_FINANCE_BASEURL}/api/general/leaseinvoiceimport/getimportgroups`,
  LEASE_INVOICE_IMPORT_DELETE: `${LEASE_FINANCE_BASEURL}/api/general/leaseinvoiceimport/delete/`,
  LEASE_RECEIPT_IMPORT_SAVE: `${LEASE_FINANCE_BASEURL}/api/general/leasereceiptimport/save`,
  LEASE_RECEIPT_IMPORT_SEARCH: `${LEASE_FINANCE_BASEURL}/api/general/leasereceiptimport/search`,
  LEASE_RECEIPT_IMPORT_GROUPS: `${LEASE_FINANCE_BASEURL}/api/general/leasereceiptimport/getimportgroups`,
  LEASE_RECEIPT_IMPORT_DELETE: `${LEASE_FINANCE_BASEURL}/api/general/leasereceiptimport/delete/`,
  // Property Master Import - import-only (no search/delete/import-groups on
  // this page, per instruction). Pointed at LEASE_FINANCE_BASEURL for
  // consistency with the other "general/<module>" imports above. Given as
  // localhost:7260 (a local dev instance) - if that's not yet on the shared
  // leasefinanceapi host, point REACT_APP_BACKEND_URL_LeaseFinance at it
  // directly to test.
  PROPERTY_IMPORT_SAVE: `${LEASE_FINANCE_BASEURL}/api/general/propertymaster/save`,
  // Unit Master Import - same import-only shape as Property Master Import
  // above (confirmed against UnitMasterController.cs / SH_UnitMasterService
  // in Pro360ERP API Erini: only Save + DownloadTemplate exist, no
  // search/delete/import-groups).
  UNIT_IMPORT_SAVE: `${LEASE_FINANCE_BASEURL}/api/general/unitmaster/save`,
  // Customer Master Import - same import-only shape as Property/Unit Master
  // Import above (confirmed against CustomerMasterController.cs /
  // SH_CustomerMasterService in Pro360ERP API Erini: only Save +
  // DownloadTemplate exist).
  CUSTOMER_IMPORT_SAVE: `${LEASE_FINANCE_BASEURL}/api/general/customermaster/save`,

  // Agent Master (confirmed from Swagger - api/general/agentmaster).
  // Points at the Lease Finance backend (REACT_APP_BACKEND_URL_LeaseFinance)
  // since this API doesn't exist on the shared BASEURL.
  AGENT_MASTER_SAVE: `${LEASE_FINANCE_BASEURL}/api/general/agentmaster/save`,
  AGENT_MASTER_UPDATE: `${LEASE_FINANCE_BASEURL}/api/general/agentmaster/update`,
  AGENT_MASTER_LIST: `${LEASE_FINANCE_BASEURL}/api/general/agentmaster/getlist`,
  AGENT_MASTER_GET_BY_ID: `${LEASE_FINANCE_BASEURL}/api/general/agentmaster/getbyid`,
  AGENT_MASTER_DOC_EXPIRY: `${LEASE_FINANCE_BASEURL}/api/general/agentmaster/getdocumentexpiry`,
  AGENT_MASTER_DROPDOWNS: `${LEASE_FINANCE_BASEURL}/api/general/agentmaster/loaddropdownsandgrids`,

  // Email Queue (confirmed from Swagger - api/general/emailqueue). Same
  // Lease Finance backend as the other api/general/* actions above.
  EMAIL_QUEUE_SEND: `${LEASE_FINANCE_BASEURL}/api/general/emailqueue/sendemail`,
  // Invoice PDFs generated for Send Email must be uploaded here (same server
  // as EMAIL_QUEUE_SEND above), not the main lease API's FileUpload - that
  // saves to a completely different server's disk, which is why attachments
  // built from it never actually reached the sent email. Confirmed live on
  // the local dev instance (files-only multipart, same shape as the other
  // api/general/uploads/* actions) - files are named by Lease No so the
  // backend/whoever consumes this folder can key off that.
  UPLOAD_LEASE_INVOICE: `${LEASE_FINANCE_BASEURL}/api/general/uploads/uploadleaseinvoice`,
  // Confirmed static file URL for an uploaded lease invoice - wwwroot/uploads
  // is served at the site root, so this is just BASEURL + the physical path
  // (F:\LeaseFinance.Api\wwwroot\uploads\finance\lease\<leaseNo>.pdf) with a
  // "<leaseNo>.pdf" appended by the caller.
  LEASE_INVOICE_FILE_BASE: `${LEASE_FINANCE_BASEURL}/uploads/finance/lease`,

  // Customer Master RA (api/general/customerra) - dedicated backend for the
  // customerMasterRA module, same Lease Finance host as the other
  // api/general/* actions above (confirmed live on the local dev instance,
  // same as agentmaster/emailqueue/etc.).
  GET_CUSTOMER_RA: `${LEASE_FINANCE_BASEURL}/api/general/customerra/get`,
  CUSTOMER_RA_MULTI: `${LEASE_FINANCE_BASEURL}/api/general/customerra/getmultipledropdown`,
  CUSTOMER_RA_COMMON: `${LEASE_FINANCE_BASEURL}/api/general/customerra/getcommondata`,
  CREATE_CUSTOMER_RA: `${LEASE_FINANCE_BASEURL}/api/general/customerra/createcustomer`,
  EDIT_CUSTOMER_RA: `${LEASE_FINANCE_BASEURL}/api/general/customerra/editcustomer`,
  // Not yet called from any customerMasterRA page - customerMaster.js today
  // bundles this same data into one CREATE_CUSTOMER_RA request instead of a
  // separate follow-up call. Defined here so it's ready to wire in once the
  // create/edit flow is split into two steps to match this action.
  CUSTOMER_RA_ADDITIONAL: `${LEASE_FINANCE_BASEURL}/api/general/customerra/insertalladditionaldetails`,

  // Unit Master RA (api/general/unitmanagementra) - dedicated backend for the
  // unitMasterRA module, same Lease Finance host as above.
  GET_UNIT_RA_LIST: `${LEASE_FINANCE_BASEURL}/api/general/unitmanagementra/getall`,
  UNIT_RA_MULTIDROP: `${LEASE_FINANCE_BASEURL}/api/general/unitmanagementra/getmultipledropdown`,
  UNIT_RA_CASCAD: `${LEASE_FINANCE_BASEURL}/api/general/unitmanagementra/getcascaddropdown`,
  UNIT_RA_COMMON: `${LEASE_FINANCE_BASEURL}/api/general/unitmanagementra/getcommondata`,
  CREATE_UNIT_RA: `${LEASE_FINANCE_BASEURL}/api/general/unitmanagementra/create`,
  UPDATE_UNIT_RA: `${LEASE_FINANCE_BASEURL}/api/general/unitmanagementra/update`,
  // Not yet called from any unitMasterRA page - listing.js reads rows already
  // in memory instead of fetching by id, and has no delete action wired up.
  GET_UNIT_RA_BY_ID: `${LEASE_FINANCE_BASEURL}/api/general/unitmanagementra/getbyid/`,
  DELETE_UNIT_RA: `${LEASE_FINANCE_BASEURL}/api/general/unitmanagementra/delete/`,
};
